var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 px-auto"},[_c('span',{style:({color:_vm.$store.getters.getColorPalette().accentCode})},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('div',{ref:"graph"})])
}
var staticRenderFns = []

export { render, staticRenderFns }